import { IconCheckDefault } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

export const RCFProductExplanation = () => {
    return (
        <>
            <Text className="text-xl font-bold">
                <FormattedMessage
                    id="_.rcf_approved_view.product_explanation_title"
                    defaultMessage="Here's how it works:"
                />
            </Text>
            <div className="space-y-m">
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_1"
                                defaultMessage="Activate your Flexi credit line today."
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_1_subtext"
                                defaultMessage="Gain access to the full credit limit."
                            />
                        </Text>
                    </div>
                </div>
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_2"
                                defaultMessage="Withdraw money anytime without fees."
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_2_subtext"
                                defaultMessage="No need to reapply."
                            />
                        </Text>
                    </div>
                </div>
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_3"
                                defaultMessage="Interest is only charged on the outstanding monthly balance."
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_3_subtext"
                                defaultMessage="Repayments can be made at any time free of charge."
                            />
                        </Text>
                    </div>
                </div>
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_4"
                                defaultMessage="Your interest-free period lasts for 12 months."
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.product_explanation_bullet_4_subtext"
                                defaultMessage="Extension possible after a new credit check. Alternatively, you can close your credit line from the 3rd month and repay the outstanding amount in 12 monthly instalments."
                            />
                        </Text>
                    </div>
                </div>
            </div>
        </>
    );
};
